import { MeterSubmissionKind } from "../types/meter";
import type { MeterProviderInfo, MeterProviderTabItem, MeterSettingsResponse, RequiredMeterSettingsField } from "../types/meter";
import type { AddressWithProviders } from "../types/models";

const IDENTITY_FIELDS: RequiredMeterSettingsField[] = ["reportName", "reportAddress", "reportCustomerCode", "reportPhone"];

const findMissingMeterSettings = (
  settings: Pick<MeterSettingsResponse, "reportName" | "reportAddress" | "reportCustomerCode" | "reportPhone" | "reportEmail">,
  provider: Pick<MeterProviderInfo, "submission">,
): RequiredMeterSettingsField[] => {
  const missing = IDENTITY_FIELDS.filter((field) => !settings[field]?.trim());
  if (provider.submission === MeterSubmissionKind.EMAIL && !settings.reportEmail?.trim()) missing.push("reportEmail");
  return missing;
};

const addressEnabledForMeterProvider = (address: AddressWithProviders, providerId: number): boolean =>
  (address.providers ?? []).some((ap) => ap.providerId === providerId && ap.meterReadingEnabled);

const formatMeterProviderTabLabel = (providerName: string, addressName: string | null): string => (addressName ? addressName : providerName);

const buildMeterProviderTabItems = (providers: MeterProviderInfo[]): MeterProviderTabItem[] =>
  providers.map((provider) => ({ provider, addressName: provider.addressName }));

export { findMissingMeterSettings, addressEnabledForMeterProvider, formatMeterProviderTabLabel, buildMeterProviderTabItems };
